import AwesomePhonenumber from 'awesome-phonenumber';

export const phone = {
  validate: value => {
    return new AwesomePhonenumber(value).isPossible();
  }
};
